export interface IAdmissionType {
    id: number,
    name: string
}

export enum AdmissionType {
    Student = 1,
    Employee = 2
}